<template>
  <v-container>
   <v-row>
      <v-col
        xs="12"
      >
        <v-card >
          <v-card-title>
            <span color="info">
              <strong>{{subattending.transaction.platform_id || 'Sem código'}}</strong> 
              - {{subattending.transaction.payment.name}} <strong v-if="subattending.attending.finished_at" class="approved"> APROVADA </strong> <span v-else> {{subattending.transaction.status.name}} </span>
            </span>
          </v-card-title>
          <v-card-text>            
            <v-row cols="12">
              <v-col md="6">
                <div v-if="subattending.new_transaction">
                  Nova tentativa de compra via {{subattending.new_transaction.payment.name}} {{subattending.new_transaction.status.name}} ({{subattending.new_transaction.platform_id}})                           
                </div>
                <div>
                  <p>Cliente: <strong>{{subattending.transaction.subcustomer.name}}</strong></p>
                  <p>Contatos:</p>
                  <ul>
                    <li v-if="subattending.transaction.subcustomer.checkout_phone">
                      {{`Telefone: ${subattending.transaction.subcustomer.checkout_phone}`}}
                    </li>
                    
                    <li v-if="subattending.transaction.subcustomer.checkout_email">
                      {{`Email: ${subattending.transaction.subcustomer.checkout_email}`}}
                    </li>

                  </ul>
                  <div v-if="subattending.affiliate">
                    <p>Afiliado: </p>
                    {{subattending.affiliate && subattending.affiliate.name}}
                  </div>
                  <div v-else>
                    <p>Pedido sem afiliado</p>
                  </div>
                </div>
              </v-col>
              <v-col md="6">
                <p>
                  {{`Pedido iniciado em: ${formattedOrderDate}`}}
                </p>
                <div v-if="subattending.transaction.due_date">
                  <p>
                    <u>Data de Vencimento do Boleto: {{subattending.transaction.due_date}}</u>
                  </p>
                </div>
                <div v-if="subattending.transaction.product">
                  <p>Produtos do Pedido: </p>
                  <div>
                    <ul>
                      <li v-for="product in subattending.transaction.product" :key="product">
                        <a v-bind:href="product.link" target='_blank'>{{ product.name }}</a> - Qtd: {{ product.pivot.qtd }}
                      </li>
                    </ul>
                  </div>                
                </div>
                <p>Total: BRL {{subattending.transaction.amount.replace('.', ',')}}</p>
                <p v-if="subattending.plan">Plano: {{subattending.plan.name}}</p>

                <v-alert
                  outlined
                  type="warning"
                  prominent
                  border="left"
                  v-if="scheduledToday"
                >
                  Atendimento agendado para hoje!
                </v-alert>
                <div v-else>
                  <p v-if="schedule" >
                    Atendimento agendado para: {{formatedScheduleDate}}
                  </p>
                </div>
              </v-col>
            </v-row>
            <v-btn 
              color="success" 
              x-medium dark
              @click="contactedAt"
              >
              Contatar
              <v-icon right>mdi-whatsapp</v-icon>
            </v-btn>
            <v-btn 
              color="default" 
              x-medium
              v-if="scheduleAction"              
              @click="$emit('openScheduleDialog', schedule ? schedule : subattending)"
              >
              Agendar atendimento
              <v-icon right>mdi-calendar</v-icon>
            </v-btn>
          </v-card-text>

        </v-card>
      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
import moment from 'moment'

import request from '../../../request';

export default {
  name: "AttendingCard",


  computed: {
      formattedOrderDate() {
        const date = moment(this.subattending.transaction.start_date || this.subattending.transaction.created_at);
        return `${date.format('DD/MM/YYYY')} às ${date.format('HH:mm')}`
      },
      formatedScheduleDate() {
        return moment(this.schedule.next_contact_at).format('DD/MM/YYYY')
      },
      scheduledToday() {
        return this.schedule && moment(this.schedule.next_contact_at).isSame(moment(), 'day')
      }
  },  

  methods: {
    async openWhatsLink() {
        const wppApi = 'https://api.whatsapp.com/send?phone=';
        const phoneNumber = this.subattending
          .transaction
          .subcustomer
          .checkout_phone
          .replace(/\s|\+*/g,'');

        const message = await request({
          method: 'get',
          url: `/api/messages/transaction/${this.subattending.transaction.id}/3`,
          auth: true,
        });

        window.open(encodeURI(`${wppApi}55${phoneNumber}&text=${message.data}`), "_blank");
    },
    contactedAt(event){
      this.openWhatsLink();

      request({
        method: 'post',
        url: `api/attendings/subattending/${this.subattending.id}/contacted`,
        auth: true
      })

      .then (response => this.$emit("updateCurrentAttending"))
      .catch(err => console.error(err));
    },
    barcodeLink (link) {   
      window.open(link, "_blank");    
    },
    copyBarCode () {
      let testingCodeToCopy = this.$refs.BarCode
      testingCodeToCopy.setAttribute('type', 'text')
      testingCodeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'foi copiado' : 'não pode ser copiado';
        alert('O código de barras ' + msg);
      } catch (err) {
        alert('oops, aconteceu algo de errado.');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
  },

  props: {
    subattending: {
      type: Object,
      required: true,
    },
    schedule: {
      type: Object
    },
    scheduleAction: {
      type: Boolean
    },
    status: {
      type: 3
    }
  },
}
</script>

<style>
  .approved{
    color:green;
  }
</style>